import React, { useEffect, useRef, useState } from 'react';
import Hls from 'hls.js';

// LIVE-RECORDING-VIDEO-LIBRARY-1 · 비공개 원본 HLS 재생 (서명 토큰) · 언마운트 시 정지·해제.
// REPLAY-R2-DELIVERY-OPT-1 · refresh(선택): 403(만료) 시 새 주소로 이어서 재생 · 404(공개 중지) 시 안내.
const MAX_REFRESH = 3;

export const HlsPlayer = ({ src, testId = 'recording-hls-player', refresh = null }) => {
  const ref = useRef(null);
  const [err, setErr] = useState(null);
  useEffect(() => {
    const el = ref.current;
    if (!el || !src) return undefined;
    setErr(null);
    let hls = null;
    if (Hls.isSupported()) {
      hls = new Hls({ maxBufferLength: 30 });
      let tries = 0;
      hls.on(Hls.Events.ERROR, async (_e, d) => {
        const code = d.response && d.response.code;
        if (refresh && code === 403 && tries < MAX_REFRESH) {
          tries += 1;
          const at = el.currentTime;
          const next = await refresh().catch(() => null);
          if (next && hls) { hls.loadSource(next); hls.startLoad(at); return; }
        }
        if (refresh && code === 404) { hls.stopLoad(); setErr('다시보기가 종료되었거나 비공개로 전환되었습니다.'); return; }
        if (d.fatal) setErr('원본 재생에 실패했습니다. 잠시 후 다시 시도해 주세요.');
      });
      hls.loadSource(src);
      hls.attachMedia(el);
    } else if (el.canPlayType('application/vnd.apple.mpegurl')) {
      el.src = src;
    } else {
      setErr('이 브라우저는 원본 녹화 재생을 지원하지 않습니다.');
    }
    return () => {
      el.pause();
      if (hls) { hls.destroy(); hls = null; }
      el.removeAttribute('src');
      el.load();
    };
  }, [src, refresh]);
  return (
    <div className="space-y-1">
      <video ref={ref} controls playsInline className="block mx-auto max-h-[60vh] max-w-full rounded bg-black" data-testid={testId}
             onError={() => setErr('원본 재생에 실패했습니다.')} />
      {err && <p className="text-xs text-red-600" data-testid={`${testId}-error`}>{err}</p>}
    </div>
  );
};
